<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-row type="flex" class="row-bg">
          <el-col :span="23">
            <span class="table-title">Grupo</span>
          </el-col>
          <el-col :span="1">
            <router-link to="/role/create">
              <el-button type="primary" icon="el-icon-plus"></el-button>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <div class="row" v-loading="loading">
        <div class="col">
          <data-tables :data="list" :table-props="tableProps">
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                             sortable="custom">
            </el-table-column>
          </data-tables>
        </div>

      </div>
    </el-card>
    <router-view></router-view>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'role-index',
    data() {
      return {
        loading: false,
        titles: [{prop: 'id', label: '#'},
          {prop: 'name', label: 'Nome'}],
        tableProps: {
          border: false,
          stripe: true
        }
      }
    },
    computed: {
      ...mapState('Role', ['list'])
    },
    methods: {
      ...mapActions('Role', ['setList']),
      async load() {
        if (_.isEmpty(this.list)) {
          this.loading = true
           await this.setList()
          this.loading = false
        }
      },
      visualizar(id) {
        this.$router.push({name: 'role.show', params: {id}})
      }
    },
    mounted() {
      this.load();
    }
  }
</script>

<style scoped>
  .table-title {
    font-size: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Role/index.vue